module.exports = __webpack_public_path__ + "static/media/icon-card-default.f71c0cc1.png";